<template>
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
    <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
      <path
        d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
      />
    </symbol>
  </svg>
  <Modal
    title="Activate your access to Participation"
    ref="activateModal"
    :static="true"
    :hide-close="true"
  >
    <template #body>
      <template v-if="!isVirtualClub || isEnabledForVirtualClub">
        <h5>Benefits:</h5>
        <div v-html="settings?.activationModalBodyText" />
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="flexCheckDefault"
            v-model="checked"
          />
          <label class="form-check-label" for="flexCheckDefault">
            I have read and agree to the
            <a :href="data?.activationTermsAndConditionURL" target="_blank"
              >Terms and Conditions</a
            >
          </label>
        </div>
      </template>
      <template v-else>
        <div class="alert alert-danger d-flex align-items-center" role="alert">
          <svg
            class="bi flex-shrink-0 me-2"
            width="24"
            height="24"
            role="img"
            aria-label="Danger:"
          >
            <use xlink:href="#exclamation-triangle-fill" />
          </svg>
          <div>
            Participation feature cannot be activated or joined as your club is a Virtual
            Club and has no physical location.
          </div>
        </div>
      </template>
    </template>
    <template #footer>
      <button
        type="button"
        class="btn btn-primary"
        @click="activate"
        :disabled="!checked"
      >
        Submit
      </button>
      <button type="button" class="btn btn-secondary" @click="goBack">
        Cancel
      </button>
    </template>
  </Modal>

  <Notification ref="notificationMsg" colorScheme="text-bg-success">
    <template #body
      ><i class="bi bi-check-circle"></i> Thank you for activating your facility's
      Participation access.</template
    >
  </Notification>

  <Notification ref="errorNotificationMsg" colorScheme="text-bg-danger">
    <template #body>
      <i class="bi bi-exclamation-circle"></i> {{ activationErrorMessage }}
    </template>
  </Notification>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { useAuthStore } from "@/stores/auth-store";
import Modal from "@/components/common/Modal.vue";
import Notification from "@/components/common/Notification.vue";
import { useEmailStore } from "@/stores/email-store";
import { useDashboardStore } from "@/stores/dashboard-store";
import { useSettingStore } from "@/stores/setting-store";
const { isClubActivated, activateClub } = useDashboardStore();

const { getSetting } = useSettingStore();
const { setting } = storeToRefs(useSettingStore());

const authStore = useAuthStore();
const { isClubhouseUser, isAuthenticated, isVirtualClub, liveUrl } = storeToRefs(authStore);
const { data } = storeToRefs(useDashboardStore());
const { sendParticipationActivationSystemEmail } = useEmailStore();

const checked = ref(false);
const activateModal = ref<any | null>(null);
const settings = ref(setting);
const activationErrorMessage = ref('');
onMounted(async () => {
  await getSetting();
  const hasClubActivated = await isClubActivated();
  if (isAuthenticated.value && isClubhouseUser.value && !hasClubActivated) {
    activateModal.value.show();
  }
});

const isEnabledForVirtualClub = computed(() => {
  return isVirtualClub && setting.value.enableVirtualClub
});

let notificationMsg = ref<any | null>(null);
const errorNotificationMsg = ref<any | null>(null);
const activate = async () => {
  const activationResult = await activateClub();
  if (activationResult.isActivated) {
    activateModal.value.hide();

    //send email notification by using Participation Activation System Email template
    const result = await sendParticipationActivationSystemEmail();
    if (result > 0) {
      notificationMsg.value.show();
    }
  } else {
    activationErrorMessage.value = activationResult.errorMessage;
    errorNotificationMsg.value.show();
  }
};

const goBack = () => {
  window.location.href = liveUrl.value;
}
</script>

<style scoped></style>
